import * as React from "react";
import { FlexBox } from "scuid-x";
import "./GenErrorPage.css";
import { HeaderAndFooter } from "./HeaderAndFooter";

export interface GenErrorPageProps {
  title: string;
  description: React.ReactChild;
  children?: React.ReactChild|React.ReactChild[];
}

export const GenErrorPage: React.SFC<GenErrorPageProps> = (props) => {
  return (
    <HeaderAndFooter>
      <div className={"GenErrorPage-main-div"}>
        <FlexBox
          className={"GenErrorPage-flex"}
          justifyContent="center"
          alignItems="left"
          direction="column"
        >
          <h3 className={"GenErrorPage-title"}>{props.title}</h3>
          <p className={"GenErrorPage-description"}>
            {props.description}
          </p>
          <div className={"GenErrorPage-childrenContainer"}>
            {props.children}
          </div>
        </FlexBox>
      </div>
    </HeaderAndFooter>
  );
};



// WEBPACK FOOTER //
// ./src/components/GenErrorPage.tsx